import * as React from 'react';
import { Map as FullwidthMap, IMapCoordinates } from '@cian/frontend-newbuilding-map-component';
import {
  TCustomBalloonFetchHtmlFunction,
  TGeoObjectsFetchFunction,
} from '@cian/frontend-newbuilding-map-component/es/types';
import * as styles from './Map.css';

interface IMapProps {
  apiKey: string;
  onGeoObjectsFirstFetch: TGeoObjectsFetchFunction;
  onCustomBalloonHtmlFetch: TCustomBalloonFetchHtmlFunction;
  pinCoordinates: IMapCoordinates;
  zoom: number;
  currentTypes: string[];
}

export function Map(props: IMapProps) {
  const { apiKey, onCustomBalloonHtmlFetch, onGeoObjectsFirstFetch, pinCoordinates, zoom, currentTypes } = props;

  return (
    <section className={styles['map']}>
      <FullwidthMap
        geoObjectNames={currentTypes}
        media={[
          {
            minWidth: -Infinity,
            maxWidth: Infinity,
            options: {
              center: pinCoordinates,
              styles: { width: '100%', height: '100%' },
              animationDuration: 300,
              defaultZoom: zoom,
            },
          },
        ]}
        firstPaintOptions={{
          apiKey,
          fetch: {
            onGeoObjectsFetch: onGeoObjectsFirstFetch,
            onCustomBalloonHtmlFetch,
          },
          id: 'pik-map',
          controls: [{ type: 'ZoomControl' }, { type: 'GeolocationControl' }, { type: 'FullscreenControl' }],
          styles: { width: '100%', height: '100%' },
        }}
      />
    </section>
  );
}
